export enum ChangeTaskColumn {
    STATUS = 'status'
  }

  export enum ChangeTaskStatus {
    INCOMPLETE = 'incomplete',
    PTL_COMPLETE = 'ptl_complete',
    FAILED = 'failed',
    REJECTED = 'rejected',
    COMPLETED = 'completed'
  }

  export const changeTaskColumn = Object.values(ChangeTaskColumn) as string[];
